import InfoIcon from '@mui/icons-material/Info';
import PhoneIcon from '@mui/icons-material/Phone';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Stack,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';

import { resolvePhoneNumberFormat } from '@shared-components-web';
import useCollectionsDialogStore from '@src/store/modules/collections-dialog.store';
import useFacilityStore from '@src/store/modules/facility.store';

const CollectionsBlockedDialog = () => {
	const { open, closeDialog } = useCollectionsDialogStore((s) => s);
	const theme = useTheme();
	const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const { facility } = useFacilityStore((store) => store);
	const phoneNumber = facility?.phoneNumber || '';

	return (
		<Dialog open={open} onClose={closeDialog} data-test-id="collections-blocked-dialog" maxWidth="sm" fullWidth>
			<DialogTitle>
				<Stack alignItems="center">
					<InfoIcon fontSize="large" sx={{ color: 'info.dark', py: 3 }} />
					<Typography
						variant={isExtraSmallScreen ? 'header4' : 'header3'}
						color="text.primary"
						textAlign="center"
					>
						There is an issue with your account
					</Typography>
				</Stack>
			</DialogTitle>
			<DialogContent sx={{ pb: 2 }}>
				<Stack spacing={2}>
					<Typography
						variant={isExtraSmallScreen ? 'bodyMediumBook' : 'bodyLargeBook'}
						color="text.secondary"
						textAlign="center"
					>
						We&apos;re having trouble accessing your account. Please call the hospital to finish scheduling
						your appointment.
					</Typography>
				</Stack>
			</DialogContent>
			{phoneNumber && (
				<DialogActions sx={{ justifyContent: 'center', pb: 4 }}>
					<Button
						variant="primaryDefault"
						size="S"
						startIcon={<PhoneIcon fontSize="small" />}
						href={`tel:+1${phoneNumber}`}
						data-test-id="account-issue-call-button"
					>
						{resolvePhoneNumberFormat(phoneNumber)}
					</Button>
				</DialogActions>
			)}
		</Dialog>
	);
};

export default CollectionsBlockedDialog;
